module.exports = __webpack_public_path__ + "media/src/images/Danielle-Walker-p-500x501-8e7588524155c71de9edb11f5dc04ec5.jpeg";